/**
 * pickLightOrDarkColorKind
 *
 * Utility function used on blog post pages when the background color is not white.
 * Depending on passed value (light, dark, text) chose between light or dark output.
 */
export const pickLightOrDarkColorKind = color => (color === 'light' ? 'light' : 'dark');
